import Model, { attr, belongsTo, hasMany, type HasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import { sortByPosition } from 'invite-sign/utils/sorting';

import type AgreementPageModel from './agreement-page';
import type FlowQuestionnaire from './flow-questionnaire';
import type IdScanPage from './id-scan-page';
import type IpadConfigModel from './ipad-config';
import type PhotoPageModel from './photo-page';
import type ipadLocalizedName from './sign-in-field';
import type SignInFieldPageModel from './sign-in-field-page';
import type SummaryPageModel from './summary-page';
import type UserDocumentTemplate from './user-document-template';
import type UserDocumentTemplateConfigurationModel from './user-document-template-configuration';

export default class Flow extends Model {
  declare [Type]: 'flow';

  @belongsTo('ipad-config', { async: false, inverse: 'flows' })
  declare ipadConfig: IpadConfigModel | null;

  @belongsTo('sign-in-field-page', { async: false, inverse: 'flow' })
  declare signInFieldPage: SignInFieldPageModel | null;

  @belongsTo('agreement-page', { async: false, inverse: 'flow' })
  declare agreementPage: AgreementPageModel | null;

  @belongsTo('id-scan-page', { async: false, inverse: 'flow' })
  declare idScanPage: IdScanPage | null;

  @belongsTo('photo-page', { async: false, inverse: 'flow' })
  declare photoPage: PhotoPageModel | null;

  @belongsTo('summary-page', { async: false, inverse: 'flow' })
  declare summaryPage: SummaryPageModel | null;

  @hasMany('flow-questionnaire', { async: false, inverse: 'flow' })
  declare flowQuestionnaires: HasMany<FlowQuestionnaire>;

  @hasMany('user-document-template-configuration', { async: false, inverse: null })
  declare activeUserDocumentTemplateConfigurations: HasMany<UserDocumentTemplateConfigurationModel>;

  @attr('string')
  declare name: string;

  @attr('number')
  declare position: number;

  @attr('boolean')
  declare additionalGuests: boolean;

  @attr('boolean')
  declare enabled: boolean;

  @attr('boolean')
  declare employeeCentric: boolean;

  @attr('array')
  declare ipadLocalizedNames: ipadLocalizedName[];

  get visitorDocumentTemplateConfigurations(): UserDocumentTemplateConfigurationModel[] {
    // @ts-ignore
    if (!this.hasMany('activeUserDocumentTemplateConfigurations').value()) return [];

    return this.activeUserDocumentTemplateConfigurations.slice();
  }

  get userDocumentTemplates(): UserDocumentTemplate[] {
    return this.visitorDocumentTemplateConfigurations.map((config) => config.userDocumentTemplate).sort(sortByPosition);
  }
}
